:host{display:block}
/*# sourceMappingURL=past-eoc.component-PUHZIFRG.css.map */
